/* CDROX 2026-08-17 (SEC-01): hidrata os paineis de aba que nasceram dentro de <template>.
 *
 * Por que: a vitrine BESTSELLERS manda as 3 abas inteiras no HTML e esconde 2 com [hidden].
 * Medido na home: SUMMER SALE 50 cards visiveis, SHIRTS 30 e POLOS 24 escondidos, somando
 * 73 KB e 443 elementos (19% do DOM da home) construidos e estilizados pra ficarem invisiveis.
 * Dentro de <template> o conteudo e inerte: nao vira DOM, nao computa estilo, nao faz layout
 * e nao baixa imagem.
 *
 * Quando hidrata (o que vier primeiro):
 *   1. primeiro pointerdown/foco/tecla na lista de abas, em fase de captura, ou seja ANTES do
 *      handler do tema. Isso importa porque FeaturedCollectionsTabs.transition() faz
 *      toPanel.querySelector('product-list').reveal() quando staggerProducts esta ligado -
 *      com o product-list ainda no template aquilo seria TypeError e a aba nao trocaria.
 *      (Hoje staggerProducts esta desligado nesta loja, mas a trava fica pro dia que ligar.)
 *   2. no primeiro periodo ocioso depois do load.
 *
 * Sem JS os paineis escondidos ficam vazios - mas a troca de abas ja depende de JS hoje
 * (<featured-collections-tabs> e custom element), entao nao existe caminho novo de falha.
 */
(function () {
  if (window.__cdroxFcTabs) return;
  window.__cdroxFcTabs = true;

  var hidratar = function (tpl) {
    if (!tpl || !tpl.parentNode) return false;
    try {
      tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
      tpl.remove();
      return true;
    } catch (e) {
      return false;
    }
  };

  var hidratarTudo = function () {
    var alvos = document.querySelectorAll('template[data-cdrox-fc-panel]');
    var n = 0;
    Array.prototype.forEach.call(alvos, function (t) { if (hidratar(t)) n++; });
    return n;
  };

  var aoInteragir = function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.closest) return;
    if (!alvo.closest('featured-collections-tabs, [role="tablist"]')) return;
    hidratarTudo();
  };

  var armar = function () {
    /* fase de CAPTURA nos quatro: precisa rodar antes do handler do tema.
       'click' entra junto porque clique sintetico (el.click(), automacao, alguns leitores
       de tela) nao emite pointerdown - sem ele a aba trocaria com o painel ainda no template. */
    document.addEventListener('pointerdown', aoInteragir, true);
    document.addEventListener('click', aoInteragir, true);
    document.addEventListener('focusin', aoInteragir, true);
    document.addEventListener('keydown', aoInteragir, true);
  };

  var quandoOcioso = function () {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { hidratarTudo(); }, { timeout: 3000 });
    } else {
      setTimeout(hidratarTudo, 1200);
    }
  };

  armar();
  if (document.readyState === 'complete') quandoOcioso();
  else window.addEventListener('load', quandoOcioso, { once: true });

  /* editor de tema: section recarregada traz template novo */
  document.addEventListener('shopify:section:load', function () { hidratarTudo(); });
})();
